<sfg-header-message [content]="displayMessage" [visible]="visible"></sfg-header-message>
<br>
